"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forEachRecipe = void 0;
const prepare_1 = require("../types-internal/prepare");
function forEachRecipe(augmentativeForEach) {
    return function (action) {
        return augmentativeForEach.call(this, (0, prepare_1.prepare)(action));
    };
}
exports.forEachRecipe = forEachRecipe;
